import { IonRouterOutlet } from "@ionic/react";

import { DesktopRouterOutlet } from "./DesktopRouterOutlet";

export function DesktopStack() {
  return (
    <IonRouterOutlet animated={false}>
      <DesktopRouterOutlet />
    </IonRouterOutlet>
  );
}
